import styled from 'styled-components';
import { desktop_breakpoint } from 'pubweb-smokey/dist/components/GridSystem/_vars_widths.js';

const PostPageCTAStyles = styled.div`
  .post-page-cta-container {
    margin: 0 auto;

    .post-page-cta-fullwidth {
      > div {
        margin: 30px auto 60px;
        width: 88%;
      }
    }
  }

  @media screen and (min-width: ${desktop_breakpoint}px) {
    .post-page-cta-container {
      .post-page-cta-fullwidth {
        max-width: 800px;
        width: 100%;
      }

      .post-page-cta-fullwidth {
        margin: 0 auto;

        > div {
          width: 100%;
        }
      }
    }
  }
`;

export default PostPageCTAStyles;
